<template>
  <router-link :to="{ name: type, params: { id: id, name: $store.state.names['CVR-1-' + id] }}">{{name}}</router-link>
</template>

<script>
export default {
  name: 'participantLink',
  props: {
    'participant': { type: Object, required: true }
  },
  data () {
    return {}
  },
  computed: {
    name: function () {
      return this.participant.newestName
    },
    type: function () {
      switch (this.participant.unitType) {
        case 'VIRKSOMHED': return 'company'
        case 'PERSON':
        case 'ANDEN_DELTAGER': return 'person'
        default: return null
      }
    },
    id: function () {
      switch (this.participant.unitType) {
        case 'VIRKSOMHED': return this.participant.businessKey
        case 'PERSON':
        case 'ANDEN_DELTAGER': return this.participant.unitNumber
        default: return null
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
  
</style>
